import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'

export default class CompanyUserInviteID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
